import './ctaregister.scss'

import {LinkBaseType, WysiwygType} from 'campagne/types'
import React, {FunctionComponent} from 'react'
import {Mod, style} from 'util/campagne/style'
import {Theme} from 'views/campagne/theme'
import {ButtonTertiary} from 'views/ui/Button'

export type CtaRegisterType = {
	title: string
	link?: LinkBaseType
	text: WysiwygType
}

const styles = style('ctaregister')

export const CtaRegister: FunctionComponent<
	CtaRegisterType & {mod?: Mod<'greyraster'>}
> = ({title, link, mod, text}) => (
	<div class={styles.mod(mod)}>
		<div class={styles('raster')} />
		{title && (
			<Theme.H2
				mod={{
					green: true,
					marked: true,
					slantedtoleft: true,
					small: true
				}}
			>
				{title}
			</Theme.H2>
		)}
		<div class={styles('container')}>
			{text && <Theme.P mod={['small', 'white']}>{text}</Theme.P>}
			{link && (
				<ButtonTertiary to={link.url} id="choose-category">
					{link.description}
				</ButtonTertiary>
			)}
		</div>
	</div>
)
